var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}; // @ts-ignore


import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { templateRendering, hasListener, getListeners } from '@progress/kendo-vue-common';
import { isCompositeFilterDescriptor } from '@progress/kendo-data-query';
import { GridColumnMenuItem } from './GridColumnMenuItem';
import { GridColumnMenuItemGroup } from './GridColumnMenuItemGroup';
import { GridColumnMenuItemContent } from './GridColumnMenuItemContent';
import { Button } from '@progress/kendo-vue-buttons';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { operatorMap, getDefaultOperator, filterLogicList, defaultHideSecondFilter, booleanFilterValues, getFilterType, operators } from '../filterCommon';
import { messages, filterClearButton, filterSubmitButton, filterTitle } from '../messages';
import { GridColumnMenuFilterUI } from './GridColumnMenuFilterUI';
/**
 * @hidden
 */

export var rootFilterOrDefault = function rootFilterOrDefault(rootFilter) {
  return rootFilter || {
    filters: [],
    logic: 'and'
  };
}; // tslint:disable:max-line-length

/**
 * Can be used to check if filtering is applied to a specific field ([see example]({% slug column_menu_grid %}#toc-styling-the-column-menu-icon)). Useful for creating active filter indicators.
 */
// tslint:enable:max-line-length

export var filterGroupByField = function filterGroupByField(field, filter) {
  var rootFilter = rootFilterOrDefault(filter);
  var compositeFilters = rootFilter.filters.filter(function (f) {
    if (isCompositeFilterDescriptor(f)) {
      return f.filters && f.filters.length && f.filters.length <= 2 && !f.filters.find(function (nf) {
        return isCompositeFilterDescriptor(nf) || nf.field !== field;
      });
    }

    return false;
  });
  return compositeFilters[0] || null;
};
/**
 * @hidden
 */

var GridColumnMenuFilterVue2 = {
  name: 'KendoGridColumnMenuFilter',
  props: {
    column: Object,
    filter: Object,
    expanded: {
      type: Boolean,
      default: undefined
    },
    filterable: Boolean,
    filterOperators: {
      type: Object,
      default: function _default() {
        return operators;
      }
    },
    hideSecondFilter: {
      type: [Boolean, Object],
      default: function _default() {
        return undefined;
      }
    },
    filterUI: [String, Function, Object]
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  data: function data() {
    return {
      currentExpanded: false,
      filterGroup: null
    };
  },
  created: function created() {
    var _this = this;

    var filterGroup;

    if (this.$props.column && this.$props.column.field) {
      var filterType = getFilterType(this.$props.column.filter);
      var defaultOperator = getDefaultOperator(this.$props.filterOperators, filterType);
      filterGroup = filterGroupByField(this.$props.column.field, this.$props.filter);
      filterGroup = filterGroup ? __assign(__assign({}, filterGroup), {
        filters: filterGroup.filters.map(function (f) {
          return __assign({}, f);
        })
      }) : {
        logic: 'and',
        filters: [{
          field: this.$props.column.field,
          operator: defaultOperator
        }, {
          field: this.$props.column.field,
          operator: defaultOperator
        }]
      };

      if (filterGroup.filters.filter(function (x) {
        return x.field === _this.$props.column.field;
      }).length === 1) {
        filterGroup.filters.splice(1, 0, {
          field: this.$props.column.field,
          operator: defaultOperator
        });
      }
    }

    this.currentExpanded = this.$props.expanded || false;
    this.filterGroup = filterGroup;
  },
  methods: {
    removeGroup: function removeGroup(group, rootFilter) {
      var filters = __spreadArrays(rootFilter.filters);

      var groupIndex = filters.findIndex(function (f) {
        return f === group;
      });

      if (groupIndex > -1) {
        filters.splice(groupIndex, 1);
      }

      return __assign(__assign({}, rootFilter), {
        filters: filters
      });
    },
    insertGroup: function insertGroup(group, rootFilter) {
      return __assign(__assign({}, rootFilter), {
        filters: __spreadArrays([group], rootFilter.filters)
      });
    },
    isControlled: function isControlled() {
      return this.$props.expanded !== undefined;
    },
    onFilterExpand: function onFilterExpand() {
      var isControlled = this.isControlled();
      var nextValue = !(isControlled ? this.$props.expanded : this.currentExpanded);
      this.$emit('expandchange', nextValue);

      if (!isControlled) {
        this.currentExpanded = nextValue;
      }
    },
    filterChangeHandler: function filterChangeHandler(e, filterIndex) {
      this.filterChange(filterIndex || 0, e);
    },
    firstFilterChange: function firstFilterChange(e) {
      this.filterChange(0, e);
    },
    secondFilterChange: function secondFilterChange(e) {
      this.filterChange(1, e);
    },
    filterChange: function filterChange(filterIndex, e) {
      var filters = this.filterGroup.filters.map(function (f, i) {
        if (i === filterIndex) {
          return __assign(__assign({}, f), {
            value: e.value,
            operator: e.operator
          });
        }

        return f;
      });
      this.filterGroup = __assign(__assign({}, this.filterGroup), {
        filters: filters
      });
    },
    logicChange: function logicChange(e) {
      this.filterGroup = __assign(__assign({}, this.filterGroup), {
        logic: e.target.value.operator
      });
    },
    clear: function clear(e) {
      e.preventDefault();

      if (!hasListener.call(this, 'filterchange')) {
        return;
      }

      var field = this.$props.column.field;
      var rootFilter = rootFilterOrDefault(this.$props.filter);
      var filterGroup = filterGroupByField(field, this.$props.filter);
      var rootFilters = rootFilter.filters.filter(function (f) {
        return f !== filterGroup;
      });

      if (!rootFilters.length) {
        this.$emit('filterchange', null, {
          event: e,
          field: this.$props.column.field
        });
      } else {
        this.$emit('filterchange', __assign(__assign({}, rootFilter), {
          filters: rootFilters
        }), {
          event: e,
          field: this.$props.column.field
        });
      }

      this.$emit('closemenu');
    },
    currentFilterGroup: function currentFilterGroup() {
      return __assign(__assign({}, this.filterGroup), {
        filters: this.filterGroup.filters.filter(function (nf) {
          return nf.value !== undefined && nf.value !== null && nf.value !== '' || nf.value === null && nf.operator;
        })
      });
    },
    submit: function submit(e) {
      e.preventDefault();

      if (!hasListener.call(this, 'filterchange')) {
        return;
      }

      var field = this.$props.column.field;
      var rootFilter = rootFilterOrDefault(this.$props.filter);
      var filterGroup = filterGroupByField(field, this.$props.filter);
      var currentFilterGroup = this.currentFilterGroup();
      var updatedFilter = null;

      if (filterGroup && currentFilterGroup.filters.length > 0) {
        var rootFilters = rootFilter.filters.map(function (f) {
          if (f === filterGroup) {
            return currentFilterGroup;
          }

          return f;
        });
        updatedFilter = __assign(__assign({}, rootFilter), {
          filters: rootFilters
        });
      } else if (currentFilterGroup.filters.length === 0) {
        var rootFilters = rootFilter.filters.filter(function (f) {
          return f !== filterGroup;
        });

        if (rootFilters.length) {
          updatedFilter = __assign(__assign({}, rootFilter), {
            filters: rootFilters
          });
        }
      } else {
        updatedFilter = __assign(__assign({}, rootFilter), {
          filters: __spreadArrays(rootFilter.filters, [currentFilterGroup])
        });
      }

      this.$emit('filterchange', updatedFilter, {
        event: e,
        field: this.$props.column.field
      });
      this.$emit('closemenu');
    },
    handleFocus: function handleFocus(e) {
      this.$emit('filterfocus', e);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this2 = this;

    var h = gh || createElement;
    var _a = this.$props,
        column = _a.column,
        filterUI = _a.filterUI,
        hideSecondFilter = _a.hideSecondFilter,
        filterOperators = _a.filterOperators;

    if (!column || !column.field) {
      return h("div");
    }

    var filterType = column.filter || 'text';
    var currentHideSecondFilter = hideSecondFilter !== undefined ? hideSecondFilter : defaultHideSecondFilter[filterType];
    var localizationService = provideLocalizationService(this);
    var filters = this.filterGroup.filters;
    var currentOperators = operatorMap(filterOperators[filterType], localizationService);
    var booleanValues = operatorMap(booleanFilterValues, localizationService);
    var firstFilterCellProps = {
      field: column.field,
      value: filters[0].value,
      operator: filters[0].operator,
      operators: currentOperators,
      booleanValues: booleanValues,
      filterType: filterType
    };
    var secondFilterCellProps = {
      field: column.field,
      value: filters[1].value,
      operator: filters[1].operator,
      operators: currentOperators,
      booleanValues: booleanValues,
      filterType: filterType
    };
    var filterLogic = this.filterGroup.logic;
    var logicData = operatorMap(filterLogicList, localizationService);
    var logicProps = {
      value: logicData.find(function (item) {
        return item.operator === (filterLogic === null ? '' : filterLogic);
      }),
      data: logicData
    };
    var isFilterValid = this.currentFilterGroup().filters.length !== 0;
    var expandState = this.isControlled() ? this.$props.expanded : this.currentExpanded;
    return (// @ts-ignore function children
      h(GridColumnMenuItemGroup, this.v3 ? function () {
        return [// @ts-ignore
        h(GridColumnMenuItem, {
          title: localizationService.toLanguageString(filterTitle, messages[filterTitle]),
          attrs: _this2.v3 ? undefined : {
            title: localizationService.toLanguageString(filterTitle, messages[filterTitle]),
            iconClass: 'k-i-filter'
          },
          iconClass: 'k-i-filter',
          onMenuitemclick: _this2.onFilterExpand,
          on: _this2.v3 ? undefined : {
            "menuitemclick": _this2.onFilterExpand
          }
        }), // @ts-ignore function children
        h(GridColumnMenuItemContent, {
          show: !!expandState,
          attrs: _this2.v3 ? undefined : {
            show: !!expandState
          }
        }, _this2.v3 ? function () {
          return [h("div", {
            "class": 'kendo-grid-filter-menu-container'
          }, [h("form", {
            "class": 'k-filter-menu k-group k-reset k-border-up',
            onSubmit: _this2.submit,
            on: _this2.v3 ? undefined : {
              "submit": _this2.submit,
              "reset": _this2.clear
            },
            onReset: _this2.clear
          }, [h("div", {
            "class": 'k-filter-menu-container'
          }, [// @ts-ignore
          h(GridColumnMenuFilterUI, {
            firstFilterProps: firstFilterCellProps,
            attrs: _this2.v3 ? undefined : {
              firstFilterProps: firstFilterCellProps,
              secondFilterProps: secondFilterCellProps,
              logicData: logicProps.data,
              logicValue: logicProps.value,
              hideSecondFilter: currentHideSecondFilter,
              operators: currentOperators,
              render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
            },
            secondFilterProps: secondFilterCellProps,
            logicData: logicProps.data,
            logicValue: logicProps.value,
            onFilteruifocus: _this2.handleFocus,
            on: _this2.v3 ? undefined : {
              "filteruifocus": _this2.handleFocus,
              "logicChange": _this2.logicChange,
              "change": _this2.filterChangeHandler
            },
            onLogicChange: _this2.logicChange,
            onChange: _this2.filterChangeHandler,
            hideSecondFilter: currentHideSecondFilter,
            operators: currentOperators,
            render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
          }), h("div", {
            "class": 'k-columnmenu-actions'
          }, [// @ts-ignore function children
          h(Button, {
            type: 'reset',
            attrs: _this2.v3 ? undefined : {
              type: 'reset'
            }
          }, _this2.v3 ? function () {
            return [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])];
          } : [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])]), // @ts-ignore function children
          h(Button, {
            themeColor: 'primary',
            attrs: _this2.v3 ? undefined : {
              themeColor: 'primary',
              disabled: !isFilterValid
            },
            disabled: !isFilterValid
          }, _this2.v3 ? function () {
            return [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])];
          } : [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])])])])])])];
        } : [h("div", {
          "class": 'kendo-grid-filter-menu-container'
        }, [h("form", {
          "class": 'k-filter-menu k-group k-reset k-border-up',
          onSubmit: _this2.submit,
          on: _this2.v3 ? undefined : {
            "submit": _this2.submit,
            "reset": _this2.clear
          },
          onReset: _this2.clear
        }, [h("div", {
          "class": 'k-filter-menu-container'
        }, [h(GridColumnMenuFilterUI, {
          firstFilterProps: firstFilterCellProps,
          attrs: _this2.v3 ? undefined : {
            firstFilterProps: firstFilterCellProps,
            secondFilterProps: secondFilterCellProps,
            logicData: logicProps.data,
            logicValue: logicProps.value,
            hideSecondFilter: currentHideSecondFilter,
            operators: currentOperators,
            render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
          },
          secondFilterProps: secondFilterCellProps,
          logicData: logicProps.data,
          logicValue: logicProps.value,
          onFilteruifocus: _this2.handleFocus,
          on: _this2.v3 ? undefined : {
            "filteruifocus": _this2.handleFocus,
            "logicChange": _this2.logicChange,
            "change": _this2.filterChangeHandler
          },
          onLogicChange: _this2.logicChange,
          onChange: _this2.filterChangeHandler,
          hideSecondFilter: currentHideSecondFilter,
          operators: currentOperators,
          render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
        }), h("div", {
          "class": 'k-columnmenu-actions'
        }, [h(Button, {
          type: 'reset',
          attrs: _this2.v3 ? undefined : {
            type: 'reset'
          }
        }, _this2.v3 ? function () {
          return [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])];
        } : [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])]), h(Button, {
          themeColor: 'primary',
          attrs: _this2.v3 ? undefined : {
            themeColor: 'primary',
            disabled: !isFilterValid
          },
          disabled: !isFilterValid
        }, _this2.v3 ? function () {
          return [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])];
        } : [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])])])])])])])];
      } : [h(GridColumnMenuItem, {
        title: localizationService.toLanguageString(filterTitle, messages[filterTitle]),
        attrs: _this2.v3 ? undefined : {
          title: localizationService.toLanguageString(filterTitle, messages[filterTitle]),
          iconClass: 'k-i-filter'
        },
        iconClass: 'k-i-filter',
        onMenuitemclick: _this2.onFilterExpand,
        on: _this2.v3 ? undefined : {
          "menuitemclick": _this2.onFilterExpand
        }
      }), h(GridColumnMenuItemContent, {
        show: !!expandState,
        attrs: _this2.v3 ? undefined : {
          show: !!expandState
        }
      }, _this2.v3 ? function () {
        return [h("div", {
          "class": 'kendo-grid-filter-menu-container'
        }, [h("form", {
          "class": 'k-filter-menu k-group k-reset k-border-up',
          onSubmit: _this2.submit,
          on: _this2.v3 ? undefined : {
            "submit": _this2.submit,
            "reset": _this2.clear
          },
          onReset: _this2.clear
        }, [h("div", {
          "class": 'k-filter-menu-container'
        }, [h(GridColumnMenuFilterUI, {
          firstFilterProps: firstFilterCellProps,
          attrs: _this2.v3 ? undefined : {
            firstFilterProps: firstFilterCellProps,
            secondFilterProps: secondFilterCellProps,
            logicData: logicProps.data,
            logicValue: logicProps.value,
            hideSecondFilter: currentHideSecondFilter,
            operators: currentOperators,
            render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
          },
          secondFilterProps: secondFilterCellProps,
          logicData: logicProps.data,
          logicValue: logicProps.value,
          onFilteruifocus: _this2.handleFocus,
          on: _this2.v3 ? undefined : {
            "filteruifocus": _this2.handleFocus,
            "logicChange": _this2.logicChange,
            "change": _this2.filterChangeHandler
          },
          onLogicChange: _this2.logicChange,
          onChange: _this2.filterChangeHandler,
          hideSecondFilter: currentHideSecondFilter,
          operators: currentOperators,
          render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
        }), h("div", {
          "class": 'k-columnmenu-actions'
        }, [h(Button, {
          type: 'reset',
          attrs: _this2.v3 ? undefined : {
            type: 'reset'
          }
        }, _this2.v3 ? function () {
          return [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])];
        } : [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])]), h(Button, {
          themeColor: 'primary',
          attrs: _this2.v3 ? undefined : {
            themeColor: 'primary',
            disabled: !isFilterValid
          },
          disabled: !isFilterValid
        }, _this2.v3 ? function () {
          return [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])];
        } : [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])])])])])])];
      } : [h("div", {
        "class": 'kendo-grid-filter-menu-container'
      }, [h("form", {
        "class": 'k-filter-menu k-group k-reset k-border-up',
        onSubmit: _this2.submit,
        on: _this2.v3 ? undefined : {
          "submit": _this2.submit,
          "reset": _this2.clear
        },
        onReset: _this2.clear
      }, [h("div", {
        "class": 'k-filter-menu-container'
      }, [h(GridColumnMenuFilterUI, {
        firstFilterProps: firstFilterCellProps,
        attrs: _this2.v3 ? undefined : {
          firstFilterProps: firstFilterCellProps,
          secondFilterProps: secondFilterCellProps,
          logicData: logicProps.data,
          logicValue: logicProps.value,
          hideSecondFilter: currentHideSecondFilter,
          operators: currentOperators,
          render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
        },
        secondFilterProps: secondFilterCellProps,
        logicData: logicProps.data,
        logicValue: logicProps.value,
        onFilteruifocus: _this2.handleFocus,
        on: _this2.v3 ? undefined : {
          "filteruifocus": _this2.handleFocus,
          "logicChange": _this2.logicChange,
          "change": _this2.filterChangeHandler
        },
        onLogicChange: _this2.logicChange,
        onChange: _this2.filterChangeHandler,
        hideSecondFilter: currentHideSecondFilter,
        operators: currentOperators,
        render: filterUI && templateRendering.call(_this2, filterUI, getListeners.call(_this2))
      }), h("div", {
        "class": 'k-columnmenu-actions'
      }, [h(Button, {
        type: 'reset',
        attrs: _this2.v3 ? undefined : {
          type: 'reset'
        }
      }, _this2.v3 ? function () {
        return [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])];
      } : [localizationService.toLanguageString(filterClearButton, messages[filterClearButton])]), h(Button, {
        themeColor: 'primary',
        attrs: _this2.v3 ? undefined : {
          themeColor: 'primary',
          disabled: !isFilterValid
        },
        disabled: !isFilterValid
      }, _this2.v3 ? function () {
        return [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])];
      } : [localizationService.toLanguageString(filterSubmitButton, messages[filterSubmitButton])])])])])])])])
    );
  }
};
/**
 * Represents the GridColumnMenuFilter component.
 *
 * {% meta height:410 %}
 *  ```html-preview
 *  <div id="vueapp">
 *     <Grid :style="{height: '280px'}"
 *          :data-items="gridData"
 *          :sortable="true"
 *          :sort= "sort"
 *          :filter="filter"
 *          :expand-field="'Discontinued'"
 *          @datastatechange="dataStateChange"
 *          @expandchange="expandChange"
 *          :columns="columns">
 *       </Grid>
 *  </div>
 * ```
 * ```js
 * import { Grid, GridColumnMenuFilter } from '@progress/kendo-vue-grid';
 * import { process } from '@progress/kendo-data-query';
 *      const ColumnMenu = {
 *        props: {
 *            column: Object,
 *            sortable: [Boolean, Object],
 *            sort: {
 *                type: Array
 *            },
 *            filter: Object,
 *            filterable: Boolean
 *        },
 *        components: {
 *            GridColumnMenuFilter
 *        },
 *        template: `<div>
 *            <GridColumnMenuFilter
 *                :column="column"
 *                :filterable="filterable"
 *                :filter="filter"
 *                @closemenu ="closeMenu"
 *                @expandchange = "expandChange"
 *                @filterchange = "filterChange"
 *            />
 *        </div>`,
 *        methods: {
 *            expandChange () {
 *                this.$emit('expandchange');
 *            },
 *            closeMenu () {
 *                this.$emit('closemenu');
 *            },
 *            filterChange (newDescriptor, e) {
 *                this.$emit('filterchange', newDescriptor, e);
 *            }
 *        }
 *      };
 *
 *      Vue.component('Grid', Grid);
 *      new Vue({
 *          el: '#vueapp',
 *          components: {
 *            Grid
 *          },
 *          created: function() {
 *             this.getData();
 *          },
 *          methods: {
 *            getData: function () {
 *                let dataState = {
 *                    filter: this.filter,
 *                    sort: this.sort
 *                };
 *                this.gridData = process([{
 *                    "ProductID": 1,
 *                    "ProductName": "Chai",
 *                    "UnitsInStock": 39,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 8, 20)
 *                },{
 *                    "ProductID": 2,
 *                    "ProductName": "Chang",
 *                    "UnitsInStock": 17,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 7, 12)
 *                },{
 *                    "ProductID": 3,
 *                    "ProductName": "Aniseed Syrup",
 *                    "UnitsInStock": 13,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 8, 26)
 *                },{
 *                    "ProductID": 4,
 *                    "ProductName": "Chef Anton's Cajun Seasoning",
 *                    "UnitsInStock": 53,
 *                    "Discontinued": false,
 *                    "FirstOrderedOn": new Date(1996, 9, 19)
 *                }], dataState);
 *            },
 *            createAppState: function(dataState) {
 *                this.sort = dataState.sort;
 *                this.filter = dataState.filter;
 *                this.getData();
 *            },
 *            dataStateChange: function (event) {
 *                this.createAppState(event.data);
 *            },
 *            expandChange: function (event) {
 *                 event.dataItem[event.target.$props.expandField] = event.value;
 *                 //
 *                 // In Vue 2 context, instead of the above line, inside the expandChange method we should have the following:
 *                 //
 *                 //   Vue.set(
 *                 //     event.dataItem,
 *                 //     event.target.$props.expandField,
 *                 //     event.dataItem.expanded === undefined ? false : !event.dataItem.expanded
 *                 //   );
 *                 //
 *            }
 *          },
 *          data: function () {
 *              return {
 *                 filter: null,
 *                 sort: [],
 *                  gridData: [],
 *                  columns: [
 *                      { field: 'ProductID'},
 *                      { field: 'ProductName', title: 'Product Name' },
 *                      { field: 'UnitsInStock', title: 'Units In Stock', columnMenu: ColumnMenu }
 *                  ]
 *              };
 *          }
 *       } );
 * ```
 *
 * ### props <span class='code'>[GridColumnMenuFilterProps]({% slug api_grid_gridcolumnmenufilterprops %})</span>
 */

var GridColumnMenuFilter = GridColumnMenuFilterVue2;
export { GridColumnMenuFilter, GridColumnMenuFilterVue2 };